import React from 'react'
import { SPACE } from '../../theme'

interface IProps {
  x?: number
  y?: number
}

const Space = ({ x = 0, y = 0 }: IProps): JSX.Element => {
  return <div style={{ width: SPACE * x, height: SPACE * y }} />
}

export default Space
